import { Fragment } from 'react';
import ContentLoader from 'react-content-loader';
import { IPracticeRevision } from '../../../../modules/Practice/model';
import { RevisionCard } from '../../molecules/RevisionCard';
import { Typography } from '../../molecules/Typography';
import { getPortugueseDisciplineSlug } from '../../../utils/discipline';

interface IRevisionList {
  title: string;
  data: IPracticeRevision[];
  isLoading: boolean;
  onRevision: (id: string) => void;
  onExclude: (id: string, subject: string) => void;
  onTitleClick?: () => void;
}

//TODO: Revisar o uso do model
const RevisionList: React.FC<IRevisionList> = ({
  title,
  data,
  isLoading,
  onRevision,
  onExclude,
  onTitleClick,
}) => {
  return (
    <div className='flex flex-col gap-lg'>
      <div className='flex flex-row items-center justify-between'>
        <Typography type='titleSection' size='h5' className='uppercase'>
          {title}
        </Typography>
        <Typography size='small'>{data.length} resultados</Typography>
      </div>
      {isLoading && (
        <Fragment>
          {Array.from({ length: 10 }, (_, index) => (
            <ContentLoader
              key={index}
              backgroundColor={'#a7adba'}
              foregroundColor={'#c0c5ce'}
              viewBox='0 0 500 35'
            >
              <rect x='0' y='10' rx='2' ry='2' width='300' height='13' />
              <rect x='0' y='25' rx='2' ry='2' width='250' height='10' />
            </ContentLoader>
          ))}
        </Fragment>
      )}
      {!isLoading &&
        data.length > 0 &&
        data.map((it, i) => (
          <RevisionCard
            dateToReview={it.dateToReview}
            futureReview={it.futureRevision}
            title={it.simulatedExam || 'Simulado'}
            subject={it.subject.trim()}
            area={getPortugueseDisciplineSlug(it.areaSlug)}
            reviewAction={() => onRevision(it._id)}
            excludeAction={() => onExclude(it._id, it.subject)}
            onTitleAction={() => onTitleClick && onTitleClick()}
            key={i}
          />
        ))}
    </div>
  );
};

export default RevisionList;
